import React, { forwardRef } from "react";
import styles from "./CardBack.module.css";
import { combineClasses } from "../../../helpers/miscellaneous";

interface CardBackProps {
  width: number;
  height: number;
  status?:
    | "photo-review"
    | "photo-rejected"
    | "questionnaire"
    | "post-order-flow-completed"
    | "default";
  visible?: boolean;
}

const WavePatternSVG = () => (
  <svg width="105" height="90" viewBox="0 0 105 90" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14 20 Q 19 17, 24 20 T 34 20 T 44 20 T 54 20 T 64 20 T 74 20 T 84 20"
      stroke="#404040"
      fill="transparent"
      strokeWidth="1.5"
    />
    <path
      d="M9 40 Q 14 37, 19 40 T 29 40 T 39 40 T 49 40 T 59 40 T 69 40 T 79 40 T 89 40 T 94 40"
      stroke="#404040"
      fill="transparent"
      strokeWidth="1.5"
    />
    <path
      d="M19 60 Q 24 57, 29 60 T 39 60 T 49 60 T 59 60 T 69 60 T 79 60"
      stroke="#404040"
      fill="transparent"
      strokeWidth="1.5"
    />
    <path
      d="M12 80 Q 17 77, 22 80 T 32 80 T 42 80 T 52 80 T 62 80 T 72 80 T 82 80 T 91 80"
      stroke="#404040"
      fill="transparent"
      strokeWidth="1.5"
    />
  </svg>
);

export const CardBack = forwardRef<HTMLDivElement, CardBackProps>(
  ({ width, height, status = "default", visible = false }, ref) => {
    return (
      <div
        ref={ref}
        className={visible ? combineClasses(styles.wrapper, styles.visible) : styles.wrapper}
        style={{ width: `${width}px`, height: `${height}px` }}>
        <div
          className={combineClasses(
            styles.inner,
            status === "questionnaire" || status === "post-order-flow-completed"
              ? styles.questionnaire
              : styles.default
          )}>
          {status === "questionnaire" && (
            <svg viewBox="0 0 105 68" className={styles.questionnaireText}>
              <text x="27" y="15">
                Your
              </text>
              <text x="7" y="40">
                message
              </text>
              <text x="25" y="65">
                here!
              </text>
            </svg>
          )}
          {status === "post-order-flow-completed" && <WavePatternSVG />}
        </div>
      </div>
    );
  }
);
